<template>
  <div class="policy-compliance flex">
    <div
        v-for="(val, key) in warningData"
        :key="key"
        class="policy-warp"
        :class="{'policy-after':key !=='listingPolicyData' && key !== 'buyerProductReviewPolicy',
        'policy-bottom':key !== 'conditionBuyerComplaints' && key !== 'restrictedProductsPolicy' && key !== 'buyerProductReviewPolicy'
        }">
      <div class="policy-title">{{ policyCompliance[key] }}</div>
      <div class="policy-number"><span class="value">{{ val | defaultShow }}</span>次</div>
    </div>
  </div>

</template>

<script>
import {POLICY_COMPLIANCE} from "@/utils/condition";

export default {
  name: "policy-compliance",
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      warningData: {
        intellectualPropertyData: '',
        productSafetyData: '',
        productAuthenticityData: '',
        listingPolicyData: '',
        conditionBuyerComplaints: '',
        restrictedProductsPolicy: '',
        buyerProductReviewPolicy: ''
      },
      policyCompliance: POLICY_COMPLIANCE
    }
  },

  created() {
    for (let key in this.data) {
      if (Object.prototype.hasOwnProperty.call(this.warningData, key)) {
        this.warningData[key] = this.data[key];
      }
    }
  }
}
</script>

<style scoped lang="scss">
.policy-compliance {
  width: 700px;
  padding: 16px;
  border: 1px solid #D8DADD;
  flex-wrap: wrap;

  .policy-warp {
    width: 25%;
    text-align: center;
    color: #333;

    .policy-title {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .policy-number {
      font-size: 12px;

      .value {
        font-size: 24px;
        font-weight: bold;
        margin-right: 2px;
      }
    }
  }

  .policy-after {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      top: 8px;
      display: block;
      content: '';
      width: 1px;
      height: 40px;
      background: #E0E2E7;
    }
  }

  .policy-bottom{
    margin-bottom: 32px;
  }
}
</style>
